"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layer = void 0;
var Layer;
(function (Layer) {
    var layerNamesMap = {
        placement: 'placement',
        background: 'background',
        obstacles: 'obstacles'
    };
    var extraLayerPrefixMap = {
        backgroundExtra: 'background-',
        foreground: 'foreground-'
    };
    Layer.getRenderableLayerList = function (_a) {
        var layers = _a.layers;
        return layers.filter(function (layer) { return layer.type === 'tilelayer' && layer.name !== layerNamesMap.placement; });
    };
    Layer.getTilelayer = function (name, _a) {
        var layers = _a.layers;
        return layers.find(function (layer) { return layer.name === layerNamesMap[name]; });
    };
    Layer.getBackgroundExtraLayers = function (_a) {
        var layers = _a.layers;
        return layers.filter(function (layer) { return layer.name.startsWith(extraLayerPrefixMap.backgroundExtra); });
    };
    Layer.getForegroundLayers = function (_a) {
        var layers = _a.layers;
        return layers.filter(function (layer) { return layer.name.startsWith(extraLayerPrefixMap.foreground); });
    };
})(Layer = exports.Layer || (exports.Layer = {}));
